<app-content-container
  [isLoading]="
    (patientAddressesState$ | async)?.isLoading ||
    (!(patientAddressesState$ | async)?.error && !((patientAddressesState$ | async)?.data || []).length) ||
    (isLoadingOrders$ | async)
  "
  [error]="(patientAddressesState$ | async)?.error || (ordersError$ | async)"
>
  <div class="flex align-items-center justify-content-between flex-wrap">
    <h2 class="my-1">Addresses</h2>
    <button
      pButton
      type="button"
      label="Add New Address"
      icon="mi-round mi-add-circle-outline"
      class="p-button-text p-button-sm mt-2 sm:mt-0"
      (click)="showModal()"
      data-cy="add-new-address-button"
      appClickEvent
      eventName="profile_add_address"
    ></button>
  </div>
  <p-divider></p-divider>
  <div data-cy="address-list">
    <div *ngFor="let address of (patientAddressesState$ | async)?.data; let i = index">
      <p-divider *ngIf="i !== 0"></p-divider>
      <p-tag
        *ngFor="let addressType of mapAddressTypeValuesToTagLabels(address.types)"
        [value]="addressType"
        styleClass="p-tag-purple p-tag-sm mr-2 my-2"
        data-cy="address-type-tag"
      >
      </p-tag>
      <div class="p2 font-normal" [innerHtml]="address | formatAddress" data-cy="address"></div>
      <div class="mt-3">
        <button
          *ngFor="let buttonOption of getButtonOptions()"
          pButton
          type="button"
          [label]="buttonOption.buttonLabel"
          [disabled]="address.types.includes(buttonOption.value)"
          class="p-button-text p-button-sm mt-2 sm:mt-0 mr-4"
          (click)="addAddressType(address.id, buttonOption.value)"
          data-cy="buttonOption.buttonLabel"
          appClickEvent
          eventName="profile_set_address_as_default"
        ></button>
      </div>
    </div>
  </div>
</app-content-container>

<app-address-form [(visible)]="displayModal" (submitForm)="onAddressCreated()"></app-address-form>
<app-address-orders-form
  [(visible)]="displayAddressOrdersModal"
  (submitForm)="onAddressOrdersUpdated()"
></app-address-orders-form>
